import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsMarkPlacardType } from 'types/shared/flights-mark-placard';

export class PartnerEarnCardStore extends Store {
  @observable public partnerLoyaltyEarnMessage?: FlightsMarkPlacardType;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
PartnerEarnCardStore.DEFAULTS = {
  partnerLoyaltyEarnMessage: {}
};
